/* POSTERARTE · posterarte-blog.js
   Index de la Revista. Desde el 2026-10-01 (decision B, reference/spec-articulo-blog.md §10)
   el FILTRO YA NO ESTA AQUI: secciones y temas son enlaces a /blogs/revista/tagged/…, que
   Shopify filtra en el servidor sobre todos los articulos y pagina. El filtro en cliente que
   hubo hasta entonces solo veia la pagina actual. Quedan dos cosas:

   1. Desplegar la nube de temas en movil. El recorte lo hace el CSS con nth-child, asi que
      sin JS la nube se queda corta pero funcional.
   2. Los enlaces viejos con ?seccion=<nombre> (la miga, el mega menu y el cajon movil los
      usaron hasta el 2026-10-01, y pueden estar guardados o compartidos) se llevan a la
      pagina de esa seccion. Solo si el nombre es una de las pestañas que existen.
*/
(function () {
  'use strict';

  document.querySelectorAll('[data-pa-revista]').forEach(function (root) {
    var nube = root.querySelector('[data-pa-nube]');
    var mas  = root.querySelector('[data-pa-nube-mas]');
    if (nube && mas) {
      mas.addEventListener('click', function () {
        var abierta = nube.hasAttribute('data-abierta');
        if (abierta) nube.removeAttribute('data-abierta');
        else nube.setAttribute('data-abierta', '');
        mas.setAttribute('aria-expanded', abierta ? 'false' : 'true');
        mas.textContent = abierta ? 'Más temas' : 'Menos temas';
      });
    }

    var pedida = new URLSearchParams(location.search).get('seccion');
    if (pedida) {
      var destino = [].filter.call(root.querySelectorAll('a.pa-rev__tab'), function (a) {
        return a.textContent.trim() === pedida;
      })[0];
      if (destino) location.replace(destino.href);
    }
  });
})();
